module.exports = __webpack_public_path__ + "img/visa.4cf84c9a.png";